import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLocaleTexts, expandFlatCmsTexts } from '@/locales';

const defaultLocale = 'en';
const localeData = getLocaleTexts(defaultLocale);
const resources = localeData
  ? {
      [defaultLocale]: {
        translation: localeData.texts,
      },
    }
  : {};

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLocale,
  fallbackLng: defaultLocale,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
    bindI18nStore: 'added',
  },
});

export default i18n;

export function mergeCmsTexts(locale: string, texts: Record<string, unknown>): void {
  if (!texts || typeof texts !== 'object') return;
  const nested = expandFlatCmsTexts(texts);
  i18n.addResourceBundle(locale, 'translation', nested, true, true);
  i18n.changeLanguage(i18n.language);
}
